import axios from 'axios'
import type { FeatureFlippingResponse } from 'commons/types/featureFlippingTypes'

export const featureFlippingService = {
	getFeatureFlipping: async (): Promise<FeatureFlippingResponse> => {
		return axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}ff`).then((res) => res.data)
	}
}
